import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

import { STORAGE, TokenProvider } from './token.provider';
import { AUTH_CONFIG, AuthConfig, RequestOptions } from '~auth/providers/auth.provider';
import { Observable } from 'rxjs/Observable';
import { User } from '~auth/model';
import { CookieService } from 'ngx-cookie-service';

interface AOResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
}

interface WeirdTokenFormat {
  aud: string;
  sub: string;
  fname: string;
  lname: string;
  nbf: number;
  iss: string;
  scopes: string[];
  exp: number;
  iat: number;
  jti: string;
  email: string;
}

@Injectable()
export class DacTokenProvider extends TokenProvider {

  constructor( @Inject(STORAGE) storage: Storage, @Inject(AUTH_CONFIG) authConfig: AuthConfig, private http: HttpClient, protected cookieService: CookieService) {
    super(storage, authConfig);
  }

  signIn(username: string, password: string) {
    const headers = new HttpHeaders({ 'Authorization': 'Basic ' + btoa(username + ':' + password) });
    return this.requestToken({ headers: headers, withCredentials: true });
  }

  refresh(local?: boolean): Observable<User> {
    return local && this.isAuthenticated()
      ? Observable.of(this.populateUser(this.getToken()))
      : this.requestToken({ withCredentials: true });
  }

  requestToken(options?: RequestOptions) {
    return this.http.get<AOResponse>(`${this.authConfig.aoUrl}/auth/token`, options)
      .switchMap((response) => {
        // debugger;
        const token = response && response.access_token;
        if (!token) return Observable.of(null);

        const user = this.populateUser(token);
        const cookie = this.cookieService.get(this.authConfig.cookie);

        this.storage.setItem(this.authConfig.token, token);
        this.storage.setItem(this.authConfig.token + 'Profile', JSON.stringify(user));
        this.storage.setItem(this.authConfig.cookie, cookie);

        return Observable.of(user);
      })
      .catch(error => {
        throw Observable.throw(error);
      });
  }

  signOut(): Observable<boolean> {
    this.clearToken();

    return this.http.get(`${this.authConfig.aoUrl}/j_spring_security_logout`, { withCredentials: true })
      .catch(error => {
        try {
          this.cookieService.delete(this.authConfig.cookie, '/', ".realpage.com");
        } catch (e) {
          console.log('Failed to delete cookie');
        }
        return Observable.of(true);
      })
      .map((resp) => {
        return true;
      });
  }

  intercept(request: HttpRequest<any>): HttpRequest<any> {
    if (request.url.includes('j_spring_security_logout')) {
      return request;
    }

    if (request.url.indexOf(this.authConfig.baseUrl) === 0
      || request.url.indexOf(this.authConfig.aoUrl) === 0
      || request.url.indexOf(this.authConfig.paymentGatewayUrl) === 0) return super.intercept(request);
    return request;
  }

  private populateUser(token: WeirdTokenFormat): User;
  private populateUser(token: string): User;
  private populateUser(token: string | WeirdTokenFormat): User {
    if (!token) return null;

    const data = typeof token === 'string'
      ? this.decodeToken(token)
      : token as WeirdTokenFormat;

    return new User({
      firstName: data.fname,
      lastName: data.lname,
      scopes: data.scopes,
      email: data.email
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/providers/dac-token.provider.ts